module.exports = {
          srcSet: __webpack_public_path__ + "55890507a3ef1f18180fcdf48d73bf05-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "55890507a3ef1f18180fcdf48d73bf05-1168.png",width: 1168,height: 234}],
          src: __webpack_public_path__ + "55890507a3ef1f18180fcdf48d73bf05-1168.png",
          toString:function(){return __webpack_public_path__ + "55890507a3ef1f18180fcdf48d73bf05-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AHMoiP2ANpX/fC+X/oM9pP9xMaT/XDir/4Vq1/9reuL+eme6/zpmwPsARhtz+0Ygev9AIYD+PCyM/zcykf8rSqD/IXnF/zGD0f6Uma//aG+m+TzoLc/soKc4AAAAAElFTkSuQmCC",
          width: 1168,
          height: 234
        }